var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import './IntroMAL.scss';
import { ReactComponent as Icon } from '../KodanshaButton/Assets/Survey_Kodansha.svg';
import apiClient from '../../API/InkyAPI';
import { useAtom } from 'jotai';
import { LoginStatusAtom } from '../../store/AccountStore';
import { fetchBadges } from '../../store/BadgesStore';
import { LoginOverlayVisible } from '../../store/OverlayStore';
import { Link } from 'react-router-dom';
var SecondHeader = {
    0: 'ATTACK ON TITAN',
    1: '',
    2: '',
};
var GiftItem = function (_a) {
    var text = _a.text, type = _a.type, giftId = _a.giftId, props = __rest(_a, ["text", "type", "giftId"]);
    return _jsxs("div", { className: 'gift-item-container', children: [_jsxs("span", { className: 'gift-state-number', children: ["Step ", giftId] }), _jsxs("div", __assign({ className: 'gift-item-wrapper' }, props, { children: [type === 'ACTIVE' && _jsx(Icon, {}), giftId === 3 && type === 'CURRENT' ?
                        _jsx(Link, { target: '_blank', className: "type-".concat(type, " type-").concat(giftId, " link-join-the-party-mal"), to: { pathname: 'https://party.shingeki.tv/' }, children: _jsx("span", { className: "type-".concat(type, " type-").concat(giftId), children: text }) })
                        : _jsx("span", { className: "type-".concat(type, " type-").concat(giftId), children: text })] }))] });
};
var BadgeOrLogin = function (props) {
    var states = useMemo(function () { return ({
        0: _jsxs(_Fragment, { children: [_jsx("h3", { className: 'intro-third-header', children: "A fresh perk just for Kodansha Readers" }), _jsxs("span", { className: 'intro-ml-text', children: [_jsx("u", { onClick: function () { return props.setLoginOverlay(true); }, children: "Log in" }), " or ", _jsx("u", { onClick: function () { return props.setLoginOverlay(true); }, children: "sign up" }), " to claim your discount code."] })] }),
        1: _jsxs(_Fragment, { children: [_jsx("h3", { className: 'intro-third-header', children: "Thanks for being a Kodansha Reader!" }), _jsxs("span", { className: 'intro-ml-text', children: ["To show you our appreciation for being a Kodansha Reader, we\u2019re offering this exclusive discount* on a ticket to the ", _jsx("i", { children: "Attack on Titan" }), " Worldwide After Party. Just click or tap the \u201CClaim Code\u201D button next to this section to display your code."] }), _jsx("span", { className: 'note-text', children: "*Only one discount code is available per Kodansha Reader account. Discount codes cannot be reused." })] }),
        2: _jsx(_Fragment, { children: _jsx("h3", { className: 'intro-third-header', children: "See you at the party!" }) }),
    }); }, []);
    return states[props.id];
};
var IntroMAL = function (props) {
    var _a = __read(useAtom(LoginStatusAtom), 1), loginStatus = _a[0];
    var _b = __read(useAtom(LoginOverlayVisible), 2), setLoginOverlay = _b[1];
    var _c = __read(useState(props.redeemComics ? 2 : 0), 2), step = _c[0], setStep = _c[1];
    var _d = __read(useState(null), 2), error = _d[0], setError = _d[1];
    var _e = __read(useAtom(fetchBadges), 2), fetch = _e[1];
    useEffect(function () {
        if (loginStatus === 'LoggedIn') {
            if (props.redeemComics) {
                setStep(2);
                return;
            }
            setStep(1);
        }
        else {
            setStep(0);
        }
    }, [loginStatus, props.redeemComics]);
    var claimRewards = function () {
        apiClient.claimUserBadge(3).then(function (response) {
            if (response.data.status.message === 'Badge cannot be claimed: no more available gifts') {
                setError('Not enough gifts');
                return;
            }
            setStep(2);
            fetch({ hardFetch: true });
        });
    };
    return (_jsxs("div", { id: 'intro-ax', className: 'intro-ax-container', children: [_jsxs("div", { className: 'text-info-wrapper', children: [_jsx("h1", { className: 'intro-header', children: "Attack on Titan" }), _jsx("h2", { className: 'intro-second-header', children: "Worldwide After Party" }), _jsx(BadgeOrLogin, { setLoginOverlay: setLoginOverlay, id: step })] }), _jsxs("div", { className: 'gift-state-wrapper', children: [loginStatus === 'LoggedOut' && _jsx(GiftItem, { giftId: 1, text: 'Login', onClick: function () { return step === 0 && setLoginOverlay(true); }, type: step === 0 ? 'CURRENT' : 'ACTIVE' }), loginStatus === 'LoggedIn' && _jsx(GiftItem, { giftId: 1, text: 'Logged in', onClick: function () { return step === 0 && setLoginOverlay(true); }, type: step === 0 ? 'CURRENT' : 'ACTIVE' }), _jsx(GiftItem, { giftId: 2, text: step === 2 ? 'Code claimed' : 'Claim discount code', onClick: step === 1 && claimRewards, type: step === 1 ? 'CURRENT' : step === 2 ? 'ACTIVE' : 'LOCK' }), _jsx(GiftItem, { giftId: 3, text: step === 2 ? 'Join the party' : 'Join the party', type: step === 2 ? 'CURRENT' : 'LOCK' }), error !== null && _jsx("span", { className: 'gift-error', children: error })] })] }));
};
export default IntroMAL;
